<template>
  <div class="framer-15uspwt" data-framer-name="Process Section" name="Process Section">
    <div class="framer-118zaf1">
      <div class="framer-128hzh2"
        style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
        data-framer-component-type="RichTextContainer">
        <h2 class="framer-text framer-styles-preset-gx26df" data-styles-preset="k3Ea6rV_p"
          style="--framer-text-alignment:center;--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
          Register and Join the Smart Factory Recognition Program NOW</h2>
      </div>
      <div class="framer-glvmnq landingPageDesktop" data-framer-name="process flow" name="process flow">
        <div class="framer-1hqvnqs hidden-15sd5ma">
          <div class="framer-ngnfta" data-framer-name="Timeline Card" name="Timeline Card">
            <div class="framer-1607ula">
              <div class="framer-kvmu4p" data-framer-name="Heading" name="Heading">
                <div class="framer-m9icur"
                  style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                  data-framer-component-type="RichTextContainer">
                  <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                    style="--framer-text-alignment:left;--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
                    Register at Smart Factory Recognition Program Portal</h4>
                </div>
              </div>
              <div class="framer-1y77cn9">
                <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
                  <div class="framer-19waumt" data-framer-name="BG" name="BG">
                    <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                      data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                        sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 150px) / 3, 1px) - 4px, 1px)"
                        :src="workerlogin" alt=""
                        style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="framer-1pcy7e8">
            <div class="framer-1bratgb-container">
              <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                  fill="currentColor" aria-hidden="true" data-slot="icon"
                  color="var(--token-4324afa3-346d-44be-957a-907a2b22145f, rgb(104, 167, 243))"
                  style="width: 100%; height: 100%;">
                  <path fill-rule="evenodd"
                    d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"></path>
                </svg></div>
            </div>
          </div>
          <div class="framer-mv15ks" data-framer-name="Timeline Card" name="Timeline Card">
            <div class="framer-ec4j1s">
              <div class="framer-19mghx2" data-framer-name="Heading" name="Heading">
                <div class="framer-ixt0g6 textcutoffin4k"
                  style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none;"
                  data-framer-component-type="RichTextContainer">
                  <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                    style="--framer-text-alignment:left;--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
                    Self Assessment & Financial Pre-loan Qualifying</h4>
                </div>
              </div>
              <div class="framer-9y3pnm">
                <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
                  <div class="framer-cl3h7k" data-framer-name="BG" name="BG">
                    <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                      data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                        sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 150px) / 3, 1px) - 4px, 1px)"
                        :src="workertechsupport" alt=""
                        style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="framer-kp1ook">
            <div class="framer-scns1x-container">
              <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                  fill="currentColor" aria-hidden="true" data-slot="icon"
                  color="var(--token-4324afa3-346d-44be-957a-907a2b22145f, rgb(104, 167, 243))"
                  style="width: 100%; height: 100%;">
                  <path fill-rule="evenodd"
                    d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"></path>
                </svg></div>
            </div>
          </div>
          <div class="framer-1xxffag" data-framer-name="Timeline Card" name="Timeline Card">
            <div class="framer-yc0rhl">
              <div class="framer-zv3s2i" data-framer-name="Heading" name="Heading">
                <div class="framer-gt115b"
                  style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                  data-framer-component-type="RichTextContainer">
                  <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                    style="--framer-text-alignment:left;--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
                    On-site Smart Factory Assessment (OSFA)*</h4>
                </div>
                <div class="framer-1x88jvy"
                  style="outline:none;display:flex;flex-direction:column;justify-content:flex-start;flex-shrink:0;transform:none"
                  data-framer-component-type="RichTextContainer">
                  <p class="framer-text framer-styles-preset-11do9gc" data-styles-preset="AW4fNdX5r"
                    style="--framer-text-color:var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255))">
                    *subject to payment of OSFA fee</p>
                </div>
              </div>
              <div class="framer-x2bfxz">
                <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
                  <div class="framer-1re7zb2" data-framer-name="BG" name="BG">
                    <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                      data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                        sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 150px) / 3, 1px) - 4px, 1px)"
                        :src="workerlane" alt=""
                        style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="framer-t9yrsv">
          <div class="framer-1tiyqlk hidden-15sd5ma"></div>
          <div class="ssr-variant hidden-15sd5ma">
            <div class="framer-1b0f95w"></div>
          </div>
          <div class="framer-16qysz3 hidden-15sd5ma">
            <div class="framer-9x23dd-container">
              <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                  fill="currentColor" aria-hidden="true" data-slot="icon"
                  color="var(--token-4324afa3-346d-44be-957a-907a2b22145f, rgb(104, 167, 243))"
                  style="width: 100%; height: 100%;">
                  <path fill-rule="evenodd"
                    d="M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z"
                    clip-rule="evenodd"></path>
                </svg></div>
            </div>
          </div>
        </div>
        <div class="framer-tmug4q hidden-15sd5ma">
          <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
            <div class="framer-1hmncde-container">
              <div class="framer-4PCoL framer-pXM92 framer-bLVSP framer-Z3TAx framer-129xvm1 framer-v-129xvm1"
                data-framer-name="Variant 1" style="width: 100%; opacity: 1; transform: none;">
                <div class="framer-6w4ogy" style="opacity: 1;">
                  <div class="framer-dtebh8" data-framer-name="Heading" style="opacity: 1; height: 56px; overflow: visible;">
                    <div class="framer-1x4fixt"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-1eung3n: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                        style="--framer-text-alignment:left;--framer-text-color:var(--extracted-1eung3n, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        Post Project Audit &amp; Impact Study</h4>
                    </div>
                  </div>
                  <div class="framer-1q4k36n"
                    style="background: linear-gradient(117deg, rgb(255, 0, 251) 0%, var(--token-8bb1a94f-ff66-4f61-9be2-a74ae20c49b5, rgb(42, 104, 227)) /* {&quot;name&quot;:&quot;500&quot;} */ 100%); border-radius: 16px; box-shadow: rgba(48, 169, 255, 0.25) 0px 1px 32px 0px; opacity: 1;">
                    <div class="framer-x0cq3a" data-framer-name="BG" style="border-radius: 16px; opacity: 1;">
                      <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                        data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                          sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 216px) / 3, 1px) - 4px, 1px)"
                          :src="workerdiscuss" alt=""
                          style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="framer-qbecyx">
            <div class="framer-1w2utcp-container">
              <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                  fill="currentColor" aria-hidden="true" data-slot="icon"
                  color="var(--token-4324afa3-346d-44be-957a-907a2b22145f, rgb(104, 167, 243))"
                  style="width: 100%; height: 100%;">
                  <path fill-rule="evenodd"
                    d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z"
                    clip-rule="evenodd"></path>
                </svg></div>
            </div>
          </div>
          <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
            <div class="framer-1ogmbgn-container">
              <div class="framer-4PCoL framer-pXM92 framer-bLVSP framer-Z3TAx framer-129xvm1 framer-v-129xvm1"
                data-framer-name="Variant 1" style="width: 100%; opacity: 1; transform: none;">
                <div class="framer-6w4ogy" style="opacity: 1;">
                  <div class="framer-dtebh8" data-framer-name="Heading" style="opacity: 1; height: 56px; overflow: visible;">
                    <div class="framer-1x4fixt"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-1eung3n: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                        style="--framer-text-alignment:left;--framer-text-color:var(--extracted-1eung3n, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        Implement Project</h4>
                    </div>
                  </div>
                  <div class="framer-1q4k36n"
                    style="background: linear-gradient(117deg, rgb(255, 0, 251) 0%, var(--token-8bb1a94f-ff66-4f61-9be2-a74ae20c49b5, rgb(42, 104, 227)) /* {&quot;name&quot;:&quot;500&quot;} */ 100%); border-radius: 16px; box-shadow: rgba(48, 169, 255, 0.25) 0px 1px 32px 0px; opacity: 1;">
                    <div class="framer-x0cq3a" data-framer-name="BG" style="border-radius: 16px; opacity: 1;">
                      <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                        data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                          sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 216px) / 3, 1px) - 4px, 1px)"
                          :src="workerconstruct" alt=""
                          style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="framer-1fv8ufq">
            <div class="framer-cf71lh-container">
              <div style="display:contents"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                  fill="currentColor" aria-hidden="true" data-slot="icon"
                  color="var(--token-4324afa3-346d-44be-957a-907a2b22145f, rgb(104, 167, 243))"
                  style="width: 100%; height: 100%;">
                  <path fill-rule="evenodd"
                    d="M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z"
                    clip-rule="evenodd"></path>
                </svg></div>
            </div>
          </div>
          <div class="ssr-variant hidden-15sd5ma hidden-72rtr7">
            <div class="framer-1s99z8i-container">
              <div class="framer-4PCoL framer-pXM92 framer-bLVSP framer-Z3TAx framer-129xvm1 framer-v-129xvm1"
                data-framer-name="Variant 1" style="width: 100%; opacity: 1; transform: none;">
                <div class="framer-6w4ogy" style="opacity: 1;">
                  <div class="framer-dtebh8" data-framer-name="Heading" style="opacity: 1; height: 56px; overflow: visible;">
                    <div class="framer-1x4fixt"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-1eung3n: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <h4 class="framer-text framer-styles-preset-1io9dmz" data-styles-preset="KSopA5p0b"
                        style="--framer-text-alignment:left;--framer-text-color:var(--extracted-1eung3n, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        Identify Project</h4>
                    </div>
                    <div class="framer-9o6occ"
                      style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; transform: none; opacity: 1;"
                      data-framer-component-type="RichTextContainer">
                      <p class="framer-text framer-styles-preset-11do9gc" data-styles-preset="AW4fNdX5r"
                        style="--framer-text-color:var(--extracted-r6o4lv, var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)))">
                        Financial Assistance (optional)</p>
                    </div>
                  </div>
                  <div class="framer-1q4k36n"
                    style="background: linear-gradient(117deg, rgb(255, 0, 251) 0%, var(--token-8bb1a94f-ff66-4f61-9be2-a74ae20c49b5, rgb(42, 104, 227)) /* {&quot;name&quot;:&quot;500&quot;} */ 100%); border-radius: 16px; box-shadow: rgba(48, 169, 255, 0.25) 0px 1px 32px 0px; opacity: 1;">
                    <div class="framer-x0cq3a" data-framer-name="BG" style="border-radius: 16px; opacity: 1;">
                      <div style="position:absolute;border-radius:inherit;top:0;right:0;bottom:0;left:0"
                        data-framer-background-image-wrapper="true"><img decoding="async" loading="lazy"
                          sizes="max(max((min(max(100vw, 1px) - 96px, 1064px) - 216px) / 3, 1px) - 4px, 1px)"
                          :src="workerradar" alt=""
                          style="display:block;width:100%;height:100%;border-radius:inherit;object-position:center;object-fit:cover">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="landingPageMobile" data-framer-name="process flow" name="process flow"> 
        <div data-framer-background-image-wrapper="true" style="position: relative; border-radius: inherit; inset: 0px;">
          <img decoding="async" loading="lazy" sizes="max(min(max(100vw, 1px) - 48px, 1064px), 1px)" :src="workerfull" alt="" style="display: block; width: 100%; height: 100%; border-radius: inherit; object-position: center center; object-fit: contain;">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import workerlogin from '@/assets/workerlogin.jpeg'
import workertechsupport from '@/assets/workertechsupport.jpeg'
import workerlane from '@/assets/workerlane.jpeg'
import workerdiscuss from '@/assets/workerdiscuss.jpeg'
import workerconstruct from '@/assets/workerconstruct.jpeg'
import workerradar from '@/assets/workerradar.jpeg'
import workerfull from '@/assets/workerfull-replacement.jpg'
export default {
  name: 'part-4-landing-page',
  inheritAttrs: false,
  data() {
    return {
      workerlogin,
      workertechsupport,
      workerlane,
      workerdiscuss,
      workerconstruct,
      workerradar,
      workerfull
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/msma/components/Part4LandingPage/index.vue